import { render, staticRenderFns } from "./CommunityDirectory.vue?vue&type=template&id=52b89432&scoped=true&"
import script from "./CommunityDirectory.vue?vue&type=script&lang=js&"
export * from "./CommunityDirectory.vue?vue&type=script&lang=js&"
import style0 from "./CommunityDirectory.vue?vue&type=style&index=0&id=52b89432&lang=scss&scoped=true&"
import style1 from "./CommunityDirectory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b89432",
  null
  
)

export default component.exports